"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrescriptionsScreen = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _Screen = require("./Screen");
var _VideoChatCubbyContext = require("../VideoChatCubbyContext");
var _ = require("../..");
var _utils = require("../../../utils");
var _components = require("../../../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Title = function Title(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("h3", {
    className: "tw-label-sm-medium text-black mb-[20px]"
  }, children);
};
var Section = function Section(_ref2) {
  var title = _ref2.title,
    children = _ref2.children;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "py-[24px] text-black tw-label-regular"
  }, /*#__PURE__*/_react.default.createElement(Title, null, title), children);
};
var PrescriptionsScreen = function PrescriptionsScreen() {
  var _useVideoChatCubby = (0, _VideoChatCubbyContext.useVideoChatCubby)(),
    patient = _useVideoChatCubby.patient;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var _useRequest = (0, _utils.useRequest)((0, _utils.getMedicationsProviderUrl)(patient.id), {
      ready: (0, _utils.isPhysician)(user)
    }),
    erxSsoUrlData = _useRequest.data;
  var _useRequest2 = (0, _utils.useRequest)((0, _utils.getPatientPrescriptionsUrl)(patient.id), {
      ready: patient.isCompleted
    }),
    _useRequest2$data = _useRequest2.data,
    medications = _useRequest2$data === void 0 ? [] : _useRequest2$data,
    loadingMedications = _useRequest2.loading,
    refreshMedications = _useRequest2.refreshAsync;
  var _useFetchPrescribers = (0, _utils.useFetchPrescribers)({
      medications: medications
    }),
    prescribers = _useFetchPrescribers.prescribers;
  var _useMedications = (0, _utils.useMedications)(medications),
    validUnexpiredMedications = _useMedications.validUnexpiredMedications;
  var pastMedications = (0, _lodash.differenceBy)(medications, validUnexpiredMedications, 'prescriptionId');
  return /*#__PURE__*/_react.default.createElement(_Screen.Screen, {
    actionLabel: "Submit"
  }, /*#__PURE__*/_react.default.createElement(Section, {
    title: "New prescription"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center"
  }, erxSsoUrlData && /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    icon: "add-heavy-16",
    iconPosition: "left",
    url: erxSsoUrlData.url
  }, "Add prescription"), /*#__PURE__*/_react.default.createElement(_components.SecondaryButton, {
    onClick: refreshMedications,
    className: "ml-[16px]"
  }, "Refresh prescriptions"))), !(0, _lodash.isEmpty)(validUnexpiredMedications) && /*#__PURE__*/_react.default.createElement(Section, {
    title: "Current prescriptions"
  }, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loadingMedications
  }, /*#__PURE__*/_react.default.createElement(_.MedicationList, {
    medications: validUnexpiredMedications,
    prescribers: prescribers,
    bordered: true,
    collapsible: true
  }))), /*#__PURE__*/_react.default.createElement(Section, {
    title: "Past prescriptions"
  }, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loadingMedications
  }, /*#__PURE__*/_react.default.createElement(_.MedicationList, {
    medications: pastMedications,
    prescribers: prescribers,
    bordered: true,
    collapsible: true
  }))));
};
exports.PrescriptionsScreen = PrescriptionsScreen;